import React from 'react';

import { App as CVTApp } from '@cvt/App';

import { AuthProvider } from '@modules/Auth/contexts';
import { UserProvider } from '@modules/Users/contexts';
import { TributeWizardProvider } from '@modules/Tributes/contexts/TributeWizardContext';

import { MainLayout } from '@shared/components/layouts/MainLayout';
import { Dialogs } from '@shared/components/Dialogs';

import { Root } from '@pages/Root';

const App = () => {
  return (
    <CVTApp>
      <AuthProvider>
        <UserProvider>
          <TributeWizardProvider>
            <MainLayout>
              <Root />
              <Dialogs />
            </MainLayout>
          </TributeWizardProvider>
        </UserProvider>
      </AuthProvider>
    </CVTApp>
  );
};

export default App;
